import React from 'react';
import {
  RiCodeSSlashLine,
  RiPaletteLine,
  RiMailSendLine,
  RiToolsLine,
  RiSearchLine,
  RiVipCrownLine,
  RiShareLine,
  RiAdvertisementLine,
} from "react-icons/ri";
import "./servicepage.css";
import Navbar from '../navbar/Navbar';
import { Link } from "react-router-dom";

const services = [
  {
    title: "Web Development",
    icon: <RiCodeSSlashLine className="card__icon" />,
    desc: "Modern, responsive websites",
    button: { label: "Learn More", link: "/web" }
  },
  {
    title: "Logo Design",
    icon: <RiPaletteLine className="card__icon" />,
    desc: "Unique brand logos",
    button: { label: "Learn More", link: "/logo" }
  },
  {
    title: "E-invitation",
    icon: <RiMailSendLine className="card__icon" />,
    desc: "Digital invites for any event",
    button: { label: "Learn More", link: "/Invitation" }
  },
  {
    title: "Customized or Upgrade Website",
    icon: <RiToolsLine className="card__icon" />,
    desc: "Website revamp services",
    button: { label: "Learn More", link: "/web" }
  },
  {
    title: "SEO",
    icon: <RiSearchLine className="card__icon" />,
    desc: "Rank better in search engines",
    button: { label: "Learn More", link: "/seo" }
  },
  {
    title: "Branding",
    icon: <RiVipCrownLine className="card__icon" />,
    desc: "Build your brand identity",
    button: { label: "Learn More", link: "/branding" }
  },
  {
    title: "Social Media Marketing",
    icon: <RiShareLine className="card__icon" />,
    desc: "Grow your presence online",
    button: { label: "Learn More", link: "/socialmedia" }
  },
  {
    title: "Customized Digital Marketing",
    icon: <RiAdvertisementLine className="card__icon" />,
    desc: "Tailored marketing solutions",
    button: { label: "Learn More", link: "/digital" }
  }
];


function Servicepage() {
  return (
    <>
      <Navbar />
      <section>
        <section className='section-margin'>
          <center>
            <div className='heading-for-all' data-aos="fade-up">
              <h2>our services</h2>
            </div>
          </center>
        </section>


        <div className="container" style={{ marginTop: "33px" }}>
          <div className="row">
            {services.map((service, index) => (
              <div key={index} className="col-md-3 mb-4 cards">
                <div className="card p-4 text-center shadow rounded">
                  <div className="mb-3">{service.icon}</div>
                  <h5>{service.title}</h5>
                  <p>{service.desc}</p>
                  <br></br>
                  <div style={{ textAlign: 'center' }}>
                    <Link to={service.button.link} className="button-al">
                      {service.button.label}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Servicepage;



